import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import "../styles/Header.css";

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef();
    const location = useLocation();
    const navigate = useNavigate();
    const handleProductsClick = () => handleScrollClick("products");
    const handleAboutClick = () => handleScrollClick("about");
    const handleContactClick = () => handleScrollClick("contact");


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleScrollClick = (section) => {
        setMenuOpen(false);

        if (location.pathname === "/") {
            // Scroll directly if on homepage
            scroller.scrollTo(section, {
                smooth: true,
                duration: 600,
                offset: -80,
            });
        } else {
            // Navigate to home with scroll instruction
            navigate("/", { state: { scrollTo: section } });
        }
    };

    return (
        <>
            <header className="header">
                <div className="left">
                    <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)}>
                        &#9776;
                    </button>
                    <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
                        <img src="/logo.png" alt="Medamos Pharma" className="logo" />
                    </Link>

                </div>

                <nav className="nav-right">
                    <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Home</Link>
                    <span onClick={handleProductsClick} style={{ cursor: "pointer" }}>Products</span>
                    <span onClick={handleAboutClick} style={{ cursor: "pointer" }}>About Us</span>
                    <span onClick={handleContactClick} style={{ cursor: "pointer" }}>Contact Us</span>
                </nav>
            </header>

            {/* Dropdown Menu */}
            <nav ref={menuRef} className={`nav-links ${menuOpen ? "open" : ""}`}>
                <Link
                    to="/"
                    onClick={() => {
                        setMenuOpen(false);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                >
                    Home
                </Link>
                <span onClick={handleProductsClick} >Products</span>
                <span onClick={handleAboutClick} >About Us</span>
                <span onClick={handleContactClick} >Contact Us</span>
            </nav>
        </>
    );
}
